// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"941":"d11e84f4","992":"f0c94f0f"}[chunkId] + ".chunk.js");